import * as actionTypes from '../constants/actionTypes';
import { updateObject } from './../../../../shared/utils';

const initialState = {
  endorsementStatuses: null,
  endorsementStatusesError: null,
  endorsementStatusesLoading: false,
  endorsementStatusChangeError: null,
  endorsementStatusChangeLoading: false,
  endorsementPipelinesControlConfig: null,
  endorsementPipelinesControlConfigError: null,
  endorsementPipelinesControlConfigLoading: false,
};

const getEndorsementStatusesStart = (state, action) => {
  return updateObject(state, {
    endorsementStatusesError: null,
    endorsementStatusesLoading: true,
  });
};

const getEndorsementStatusesSuccess = (state, action) => {
  return updateObject(state, {
    endorsementStatuses: action.endorsementStatuses,
    endorsementStatusesError: null,
    endorsementStatusesLoading: false,
  });
};

const getEndorsementStatusesFail = (state, action) => {
  return updateObject(state, {
    endorsementStatuses: null,
    endorsementStatusesError: action.error,
    endorsementStatusesLoading: false,
  });
};

const changeEndorsementStatusStart = (state, action) => {
  return updateObject(state, {
    endorsementStatusChangeError: null,
    endorsementStatusChangeLoading: true,
  });
};

const changeEndorsementStatusSuccess = (state, action) => {
  return updateObject(state, {
    endorsementStatusChangeError: null,
    endorsementStatusChangeLoading: false,
  });
};

const changeEndorsementStatusFail = (state, action) => {
  return updateObject(state, {
    endorsementStatusChangeError: action.error,
    endorsementStatusChangeLoading: false,
  });
};

const getEndorsementPipelinesControlConfigStart = (state, action) => {
  return updateObject(state, {
    endorsementPipelinesControlConfigError: null,
    endorsementPipelinesControlConfigLoading: true,
  });
};

const getEndorsementPipelinesControlConfigSuccess = (state, action) => {
  return updateObject(state, {
    endorsementPipelinesControlConfig: action.endorsementPipelinesControlConfig,
    endorsementPipelinesControlConfigError: null,
    endorsementPipelinesControlConfigLoading: false,
  });
};

const getEndorsementPipelinesControlConfigFail = (state, action) => {
  return updateObject(state, {
    endorsementPipelinesControlConfig: null,
    endorsementPipelinesControlConfigError: action.error,
    endorsementPipelinesControlConfigLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ENDORSEMENT_STATUSES_START:
      return getEndorsementStatusesStart(state, action);
    case actionTypes.GET_ENDORSEMENT_STATUSES_SUCCESS:
      return getEndorsementStatusesSuccess(state, action);
    case actionTypes.GET_ENDORSEMENT_STATUSES_FAIL:
      return getEndorsementStatusesFail(state, action);

    case actionTypes.CHANGE_ENDORSEMENT_STATUS_START:
      return changeEndorsementStatusStart(state, action);
    case actionTypes.CHANGE_ENDORSEMENT_STATUS_SUCCESS:
      return changeEndorsementStatusSuccess(state, action);
    case actionTypes.CHANGE_ENDORSEMENT_STATUS_FAIL:
      return changeEndorsementStatusFail(state, action);

    case actionTypes.GET_ENDORSEMENT_PIPELINES_CONTROL_CONFIG_START:
      return getEndorsementPipelinesControlConfigStart(state, action);
    case actionTypes.GET_ENDORSEMENT_PIPELINES_CONTROL_CONFIG_SUCCESS:
      return getEndorsementPipelinesControlConfigSuccess(state, action);
    case actionTypes.GET_ENDORSEMENT_PIPELINES_CONTROL_CONFIG_FAIL:
      return getEndorsementPipelinesControlConfigFail(state, action);

    default:
      return state;
  }
};

export default reducer;
